type PatrolStatusFrontEnd = 'Clear' | 'Warning' | 'Emergency' | null;
type PatrolStatusBackend = 'Clear' | 'Attention' | 'Urgent' | null;

// Why we need to map the status?
// The status of the patrol is stored in the backend as 'Clear', 'Attention', 'Urgent'.
// But in the frontend, we use 'Clear', 'Warning', 'Emergency'.
// This also makes sure we are backward compatible with the old status values that we use in V2

export function mapFrontEndStatusToBackendStatus(
	status: PatrolStatusFrontEnd,
): PatrolStatusBackend {
	switch (status) {
		case 'Clear':
			return 'Clear';
		case 'Warning':
			return 'Attention';
		case 'Emergency':
			return 'Urgent';
		default:
			return null;
	}
}

export function mapBackendStatusToFrontEndStatus(
	status: PatrolStatusBackend,
): PatrolStatusFrontEnd {
	switch (status) {
		case 'Clear':
			return 'Clear';
		case 'Attention':
			return 'Warning';
		case 'Urgent':
			return 'Emergency';
		default:
			return null;
	}
}
